import { render, staticRenderFns } from "./dialog-btn-slot.mpx?vue&type=template&id=56840382&isComponent&outputPath=components%2Fdialog-btn-slotd50acee0%2Findex"
import script from "./dialog-btn-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-btn-slotd50acee0%2Findex"
export * from "./dialog-btn-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-btn-slotd50acee0%2Findex"
import style0 from "./dialog-btn-slot.mpx?vue&type=style&index=0&id=56840382&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_d50acee0%22%7D&isComponent&outputPath=components%2Fdialog-btn-slotd50acee0%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports